import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import GamingParlor from '@/components/outlet/GamingParlor';


const gamingParlor = () => {
    return (
        <>
            <Head>
                <title>Game Store POS System - Easy Billing & Inventory Management</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/gaming-parlor" />
                <link rel="alternate" href="https://queuebuster.co/outlet/gaming-parlor" hrefLang="en-us" />
                <meta name="description" content="Manage billing, inventory, loyalty programs, and staff effortlessly with QueueBuster’s Game Store POS system. Boost efficiency, customer satisfaction, and growth." />
                <meta property="og:title" content="Efficient Gaming Parlor POS System by QueueBuster - Streamline Billing & Inventory" />
                <meta property="og:description" content="QueueBuster's Gaming Parlor POS System enhances operations with fast billing, real-time inventory tracking, customer loyalty programs, and multi-location management. Improve customer satisfaction and streamline your gaming parlor’s workflow effortlessly." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-05.jpg" />
                <meta property="og:url" content="https://queuebuster.co/outlet/gaming-parlor" />
            </Head>
         <SchemaTags page="gaming-parlor" />
            <GamingParlor />
        </>
    )
}

export default gamingParlor